import useMutation from '../../ReactQuery/useMutation';
import { put } from '../../redux/api';

export type FinishedTrialSubmissionRequest = {
  id: number;
  submittedForm: Record<string, any>;
};

function submitFinishedTrial(params: FinishedTrialSubmissionRequest): Promise<void> {
  return put<Record<string, any>, void>(`/api/finished-trials/${params.id}`, params.submittedForm)
    .then((resp) => {
      if (resp.status >= 400) {
        throw new Error('Error while submitting finished trial survey.');
      }

      return undefined;
    });
}

/**
 * Hook used to submit a finished trial survey form.
 */
export function useSubmitFinishedTrial() {
  return useMutation({
    mutationFn: submitFinishedTrial,
  });
}
